<!-- Modal Header -->
  <ng-container>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'myFavourites.itemAdded' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true" class="show">
              <em class="material-icons">close</em>
            </span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="cx-dialog-body modal-body">
          <div class="cx-dialog-row row">
            <div class="col-md-6">
              <div *ngIf="productObj.product" class="row">
                <div class="col-md-5">
                  <cx-media
                    class="rfqSearchTumbnail"
                    [container]="getProductImageUrl(productObj)"
                    [alt]="productObj.product.name"
                  >
                  </cx-media>
                </div>

                <div class="col-md-7">
                  <div class="dialog-product-code">
                    {{ productObj.product.code }}
                  </div>

                  <a
                    class="dialog-product-name"
                    [routerLink]="
                      { cxRoute: 'product', params: productObj.product } | cxUrl
                    "
                    ><span [innerHTML]="productObj.product.name"></span
                  ></a>
                </div>
              </div>
            </div>

            <div class="col-md-6 border-left">
              <div class="cx-dialog-buttons">
                <button
                  class="vs-primary-btn"
                  autofocus
                  (click)="dismissModal('Continue Shopping')"
                >
                  {{ 'myFavourites.continueShoppingBtn' | cxTranslate }}
                </button>
                <button
                  routerLink="/quote/cart"
                  class="vs-tertiary-btn"
                  autofocus
                >
                  {{ 'myFavourites.quoteCartBtn' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'addCart.updatingCart' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="cx-dialog-body modal-body">
          <div class="cx-dialog-row">
            <div class="col-sm-12"><cx-spinner></cx-spinner></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
